export const DropboxFileProviderDisplayName = "gkc";
export const BoxFileProviderDisplayName = "hkc";
export const GoogleDriveFileProviderDisplayName = "ikc";
export const FacebookFileProviderDisplayName = "jkc";
export const RecentAttachmentsFileProviderDisplayName = "kkc";
export const EgnyteFileProviderDisplayName = "lkc";
export default {DropboxFileProviderDisplayName,BoxFileProviderDisplayName,GoogleDriveFileProviderDisplayName,FacebookFileProviderDisplayName,RecentAttachmentsFileProviderDisplayName,EgnyteFileProviderDisplayName};